import React, {Component} from 'react';
import Container from "@/components/Container";
import Iframe from '@/components/Iframe';

/**
 * 进出校补签到统计
 */
export default class ReplenishGateBase extends Component {
  render() {
    const IframeDom = Iframe({
      src: '//manage.xiaoyuanhao.com/manage/page/attendance/statistic/replenishGate/list.html',
    });

    return (
      <Container breStates defaultPadding>
        <div style={{padding: '9px 17px'}}>
          <IframeDom />
        </div>
      </Container>
    );
  }
}
